import faceApi from "@/api/faceApi";

export enum FACE_STATUS {
  FACE_STATUS_ACTIVE = 1,
  FACE_STATUS_INACTIVE = 0,
}

export interface IFace {
  id: string;
  name: string;
  status: FACE_STATUS;
  order: number;
}
export class FaceDTO implements IFace {
  id: string;
  name: string;
  status: FACE_STATUS;
  order: number;
}

export default class Face extends FaceDTO {
  constructor(dto?: FaceDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      name: "",
      status: FACE_STATUS.FACE_STATUS_ACTIVE,
    });
  }

  public save() {
    if (this.id) {
      return faceApi.update(this);
    } else {
      return faceApi.create(this);
    }
  }

  get statusName() {
    return this.status === FACE_STATUS.FACE_STATUS_ACTIVE ? "on" : "off";
  }
}
